import { fi, enUS, sv } from 'date-fns/locale';

export const SUPPORTED_LANGUAGES = ['fi', 'en', 'sv'];
export const DEFAULT_LANGUAGE = 'fi';

// Native names on purpose: a language picker names each language in itself, so these are
// deliberately not run through t().
export const LANGUAGE_LABELS = { fi: 'Suomi', en: 'English', sv: 'Svenska' };

/**
 * Reduce any language tag to one of SUPPORTED_LANGUAGES: 'sv-FI', 'SV' and 'sv_SE' all
 * become 'sv'; anything unsupported or empty becomes the default ('fi').
 */
export function normalizeLanguage(value) {
  if (typeof value !== 'string') return DEFAULT_LANGUAGE;
  const base = value.trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.includes(base) ? base : DEFAULT_LANGUAGE;
}

/**
 * Languages a picker may offer. An already-stored `current` value is always listed so a MUI
 * Select never receives an out-of-range value, even if it holds a language we later drop.
 */
export function enabledLanguages(current) {
  const languages = [...SUPPORTED_LANGUAGES];
  if (typeof current === 'string' && current !== '' && !languages.includes(current)) {
    languages.push(current);
  }
  return languages;
}

/**
 * Language a customer document (invoice, quote, receipt) should be written in: what the
 * customer asked for, otherwise what the workshop uses, otherwise Finnish. Mirrors
 * get_communication_language() on the backend so the dialog shows what will actually be sent.
 */
export function resolveDocumentLanguage(customer, organization) {
  const preferred = customer?.preferred_language;
  if (preferred) return normalizeLanguage(preferred);
  const orgDefault = organization?.default_invoice_language || organization?.default_language;
  return orgDefault ? normalizeLanguage(orgDefault) : DEFAULT_LANGUAGE;
}

const DATE_FNS_LOCALES = { fi, en: enUS, sv };

export function getDateFnsLocale(lang) {
  return DATE_FNS_LOCALES[normalizeLanguage(lang)] || fi;
}
